import { render, staticRenderFns } from "./accept-privacy.vue?vue&type=template&id=d434b6fe&"
import script from "./accept-privacy.vue?vue&type=script&lang=js&"
export * from "./accept-privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports